module.exports = __webpack_public_path__ + "img/nf.279a0832.svg";